import { render, staticRenderFns } from "./lp-opportunities-for-wine-lovers.vue?vue&type=template&id=275c8fdb&scoped=true"
import script from "./lp-opportunities-for-wine-lovers.vue?vue&type=script&lang=js"
export * from "./lp-opportunities-for-wine-lovers.vue?vue&type=script&lang=js"
import style0 from "./lp-opportunities-for-wine-lovers.vue?vue&type=style&index=0&id=275c8fdb&prod&scoped=true&lang=css"
import style1 from "./lp-opportunities-for-wine-lovers.vue?vue&type=style&index=1&id=275c8fdb&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275c8fdb",
  null
  
)

export default component.exports